// extracted by mini-css-extract-plugin
export default {"box":"checkbox_box__3gE-g","checkbox":"checkbox_checkbox__w3T6J"};